<script setup lang="ts">
// The question-mark affordance in the header: help text, plus the version of the
// running build so it can be confirmed at a glance. appVersion is baked in at image
// build time from the released git tag (see APP_VERSION in the Dockerfile) and reads
// 'dev' outside that build.
//
// Pass `text` to change the help text, or use the default slot for richer content.
// Pass `label` to render the wide labelled row the mobile menu uses instead of the
// bare icon; the trigger is styled to match its siblings in either place, so it stays
// a plain button with a UIcon like the layout's other nav controls rather than a
// UButton, whose variants carry their own text tone and hover background.
const { label } = defineProps<{
  label?: string
}>()

const { appVersion } = useRuntimeConfig().public
</script>

<template>
  <UPopover :content="{ side: 'bottom', align: 'end' }">
    <button
      :class="[
        'group flex items-center text-sm font-medium text-muted hover:text-primary transition-colors',
        label ? 'w-full gap-2 px-3' : 'px-2 py-2'
      ]"
      :aria-label="label ? undefined : 'Hjælp og version'"
    >
      <UIcon
        name="i-lucide-circle-question-mark"
        class="shrink-0 size-5 text-dimmed group-hover:text-primary transition-colors"
      />
      <span
        v-if="label"
        class="truncate"
      >{{ label }}</span>
    </button>

    <template #content>
      <div class="max-w-xs p-3 flex flex-col gap-2 text-sm">
        <slot>
          <p class="text-muted">
            Spørgsmål til bestillinger eller menuen?
          </p>
          <UButton
            color="neutral"
            variant="ghost"
            icon="i-lucide-mail"
            class="w-full cursor-pointer justify-center sm:w-auto"
          >
            Kontakt kantinen
          </UButton>

          <USeparator />
          <p class="text-muted">
            For at få adgang til administration af bestillinger, menu og produkter skal brugeren tilføjes til AD gruppen
          </p>
          <pre>DK-Canteen-Admin</pre>
          <p class="text-muted">
            For at få adgang til at oprette, ændre og slette adgang for timelønnede skal brugeren tilføjes til AD gruppen
          </p>
          <pre>DK-Production-Workers-Password-Admin</pre>
          <USeparator />

          <p class="text-xs text-dimmed">
            Version <span class="font-medium text-muted">{{ appVersion }}</span>
          </p>
        </slot>
      </div>
    </template>
  </UPopover>
</template>
